import { render } from "./employee.svg?vue&type=template&id=b679ef64"
const script = {}
script.render = render

export default script